(function () {
	const header = () => {
		$("[data-hover-opacity]").hover(
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).addClass("opacity");
				$(this).removeClass("opacity");
			},
			function () {
				const id = $(this).data("hover-opacity");
				$(`[data-hover-opacity=${id}]`).removeClass("opacity");
			}
		);

		const megaMenuTabs = () => {
			$('.mega-menu__tab-wrapper')
				.children()
				.find('.mega-menu__tab-wrapper')
				.first()
				.addClass('mega-menu__tab-wrapper--active')
			$('.mega-menu__tab-wrapper').mouseenter(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focus(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
			$('.mega-menu__tab-wrapper').focusin(function (event) {
				$('.mega-menu__tab-wrapper').removeClass(
					'mega-menu__tab-wrapper--active'
				)
				$(this).addClass('mega-menu__tab-wrapper--active')
			})
		}
		megaMenuTabs()

		// Dropdown accessibility: click toggle with second-click close
		$('.header-menu-trigger').off('click.navdropdown').on('click.navdropdown', function(e) {
			e.preventDefault();
			e.stopPropagation();
			var expanded = $(this).attr('aria-expanded') === 'true';
			$('.header-menu-trigger').not(this).attr('aria-expanded', 'false');
			$(this).attr('aria-expanded', expanded ? 'false' : 'true');
		});

	};

	// Document-level handlers for dropdown accessibility
	// Escape closes all dropdowns, click outside closes all dropdowns
	$(document)
		.off('keydown.navdropdown')
		.on('keydown.navdropdown', function(e) {
			if (e.key === 'Escape') {
				$('.header-menu-trigger').attr('aria-expanded', 'false');
			}
		})
		.off('click.navdropdownoutside')
		.on('click.navdropdownoutside', function(e) {
			if (!$(e.target).closest('.have-submenu').length) {
				$('.header-menu-trigger').attr('aria-expanded', 'false');
			}
		});

	document.addEventListener("shopify:section:load", header);
	header();
})();
